import { render, staticRenderFns } from "./IContent.vue?vue&type=template&id=7e3fe571&scoped=true"
import script from "./IContent.vue?vue&type=script&lang=js"
export * from "./IContent.vue?vue&type=script&lang=js"
import style0 from "./IContent.vue?vue&type=style&index=0&id=7e3fe571&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3fe571",
  null
  
)

export default component.exports